var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main-overview',{attrs:{"columns":_vm.columns,"statusKey":"waiting","waitingReason":_vm.$route.params.reason}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }